import { BoxOutline } from "styles/common/BoxStyle";
import { CommonWrapper } from "styles/common/Layout";
import { SwitchInput } from "styles/common/FormStyle";
import { Link, useNavigate } from "react-router-dom";
import { RowWithArrow, Row } from "styles/common/NavigationStyle";
import useAuthStore from "store/auth";
import { updateAutoLogin } from "api/user";

const NavigationBox = () => {
  const authStore = useAuthStore();
  const navigate = useNavigate();
  const user = authStore?.user;

  const toggleAutoLogin = async () => {
    try {
      const res = await updateAutoLogin(!user.autologin);
      if (res.status === 200) {
        user.autologin = !user.autologin;
        authStore.login(user, authStore.token, res?.data?.refreshToken);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const logout = () => {
    if (window.confirm("로그아웃 하시겠습니까?")) {
      authStore.logout();
      navigate("/");
    }
  };

  return (
    <CommonWrapper>
      <BoxOutline margin="20px 0 0 0">
        <Row style={{ paddingRight: 0 }}>
          <div>자동 로그인</div>
          <SwitchInput
            type="checkbox"
            checked={user?.autologin} // Update the property name to "autologin"
            onChange={toggleAutoLogin}
          />
        </Row>
        <Link to="/account/edit">
          <RowWithArrow>회원정보 수정</RowWithArrow>
        </Link>
        <Link to="/password/reset">
          <RowWithArrow>비밀번호 변경</RowWithArrow>
        </Link>
        <Link to="/phone/reset">
          <RowWithArrow>인증수단 관리</RowWithArrow>
        </Link>
        <Row onClick={logout}>로그아웃</Row>
        <Link to="/account/withdraw">
          <RowWithArrow>회원탈퇴</RowWithArrow>
        </Link>
      </BoxOutline>
    </CommonWrapper>
  );
};

export default NavigationBox;
